<template>
  <div class="content-block dx-card">
    <h2 class="content-block">Office Details</h2>
  </div>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>
  <div class="content-block dx-card" >
    <DxToolbar class="menubar">
      <DxItem
          :options="cancelButtonOptions"
          location="before"
          widget="dxButton"
        />
      <DxItem
          :options="saveButtonOptions"
          location="before"
          widget="dxButton"
        />
    </DxToolbar>
  </div>

  <div class="content-block dx-card responsive-paddings">
    <DxForm id="form" 
        :form-data="offices" 
        :label-mode="outside" 
        :read-only="false" 
        :show-colon-after-label="true"
        :label-location="top" 
        :col-count="1" 
        :min-col-width="300" 
        :width="null"
        :items="['officeId', 'officeName', 'districtId']">
      >
      <DxSimpleItem data-field="officeId"  :editor-options="{readOnly: true}" />
      <DxSimpleItem data-field="officeName" />
      <DxSimpleItem data-field="districtId" editor-type="dxSelectBox" :editor-options="districtFieldOptions()" />
    </DxForm>
  </div>
  <DxLoadPanel
    v-model:visible="loadingVisible"
    :message="Loading"
    :show-indicator="true"
    :show-pane="true"
    :shading="true"
    :hide-on-outside-click="false"
    :on-shown="onLoadPanelShown"
    :on-hidden="onLoadPanelHidden"
    shading-color="rgba(0,0,0,0.4)"
  />
  <DxToast
      v-model:visible="toastVisible"
      v-model:message="toastMessage"
      v-model:type="toastType"
      position="bottom center"
    />
  </div>
</template>

<script>

import DxForm, { DxSimpleItem } from "devextreme-vue/form";
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
// import notify from 'devextreme/ui/notify';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxToast } from 'devextreme-vue/toast';

export default {
  components: {
    DxForm, 
    DxSimpleItem, 
    DxToolbar,
    DxItem,
    DxLoadPanel,
    DxToast
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      loading: true,
      loadingVisible: false,
      toastVisible: false,
      toastMessage: '',
      toastType: 'info',
      toastPosition: {
          at: "bottom",
          my: "top",
          of: "#pwreset" },
      cancelButtonOptions: {
        icon: 'revert',
        onClick: () => {
          //this.refreshData();
          this.$router.go(-1);
        },
      },
      saveButtonOptions: {
        icon: 'save',
        onClick: () => {
          this.loadingVisible = true;
          if (this.offices.officeId==0)
          {
            this.$store.dispatch('offices/addOffice', this.offices);
            this.$emit('recordUpdated');
          }
          else
          {
            this.$store.dispatch('offices/updateOffice', this.offices);
            this.$emit('recordUpdated');
          }
          const rc = this.$store.getters["offices/getResponseCode"];
          
          if (rc >= 200 && rc <= 299)
          {
            this.toastType = 'success';
            this.toastMessage = 'Record saved (' + rc + ').';
            this.toastVisible = true;
          }
          else{
            this.toastType = 'error';
            this.toastMessage = 'Error saving record (' + rc + ').';
            this.toastVisible = true; 
          }
      
          this.loadingVisible = false;
        },
      },
    };
  },
  computed: {
    currentRecordId() {
      return this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1); 
    },
    offices() {
      return this.$store.getters["offices/getCurrentOffice"];
    },
    districts() {
      return this.$store.getters["districts/getDistricts"];
    },
  },
  methods: {
    onLoadPanelShown() {
      setTimeout(() => { this.loadingVisible = false; }, 10000);
    },
    onLoadPanelHidden() {
      // 
    },
    districtFieldOptions() {
      return {
        items: this.districts,
        valueExpr: "districtId",
        displayExpr: "districtName"
      }
    },
    refreshData(){
      this.loadPageData();
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      this.loadingVisible = true;
      try {
        await this.$store.dispatch("offices/loadOffice", { id: this.currentRecordId });
        await this.$store.dispatch("districts/loadDistricts", {forceRefresh: refresh});
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
        this.loadingVisible = false;
      }
    },
  },
};
</script>

<style scoped>
  .menubar{
    padding: 0 0 0 40px ;
  }
</style>
